import AssessmentServer from '@/api/assessment'
import modules from './modules'

export default {

    namespaced: true,
    modules: modules,

    // namespaced: true,
    //
    // state: {
    //
    //     assessmentTreeInfo: [],
    //
    // },
    //
    // getters: {
    //
    //     assessmentTreeInfo(state) {
    //         return state.assessmentTreeInfo;
    //     }
    //
    // },
    //
    // mutations: {
    //
    //     setAssessmentConfTreeInfo(state, payload) {
    //         state.assessmentTreeInfo = payload;
    //     },
    //
    // },
    //
    // actions: {
    //
    //     getAssessmentConfTreeInfo({commit}, payload) {
    //         return new Promise((resolve, reject) => {
    //             AssessmentServer.assessmentConf.tree(payload).then((responseBody) => {
    //                 commit("setAssessmentConfTreeInfo", responseBody.data);
    //             });
    //         }).catch(error => {
    //             console.log('获取ASSESSMENTCONF配置信息失败');
    //             reject(error);
    //         });
    //     },
    //
    //
    // },

}